<template>
  <div class="currency-selector">
    <div class="mobile-only menu-trigger" @click="toggleMenu">
      <span class="currency-symbol">{{selectedCurrency?.symbol}}</span>
      <span class="menu-trigger__label">{{selectedCurrency?.name}}</span>
      <span class="icon icon-chevron-down menu-trigger__arrow"></span>
    </div>
    <div class="locales-selector desktop-only" ref="currenciesDropdown">
      <div @click="toggleDropdown" class="flex">
        <span class="currency-symbol">{{selectedCurrency?.symbol}}</span>
        <span class="text-body-1 fw-medium currency-selector--currency">{{selectedCurrency?.code}}</span>
        <span class="icon icon-chevron-down"></span>
      </div>
      <div class="currency-dropdown p-overlaypanel" v-if="dropdown">
        <MobileMenuList :list="currencies" :selectedOption="selectedCurrency" @change="selectCurrency"/>
      </div>
    </div>
    <ClientOnly fallback-tag="div">
      <LazyDialog
          v-model:visible="menuVisible"
          :showHeader="false"
          position="right"
          :block-scroll="true"
          :modal="true"
          :draggable="false"
          class="mobile-menu-dialog"
      >
        <template #container>
          <div class="mobile-menu-container">
            <div @click="menuVisible = false">
              <div class="pb-4 mobile-menu-dialog-header mobile-menu-dialog-header--return">
                <button>
                  <span class="icon icon-chevron-left color-blue"></span>
                </button>
                {{$t('Select currency')}}
              </div>
            </div>
            <div>
              <MobileMenuList :list="currencies" :selectedOption="selectedCurrency" @change="selectCurrency"/>
            </div>
          </div>
        </template>
      </LazyDialog>
    </ClientOnly>
  </div>
</template>
<script setup lang="ts">
import { useMobileDialog } from '@/composables/useMobileDialog';
import MobileMenuList from "~/components/SiteHeader/MobileMenuList.vue";
import Cookies from 'js-cookie'
const { menuVisible, toggleMenu } = useMobileDialog();
import { useAccountStore } from "~/store/account";
import { useBookingStore } from "~/store/booking";
const accountStore = useAccountStore();
const bookingStore = useBookingStore();
const currencies = SUPPORTED_CURRENCIES

const selectedCurrency = ref<{ code: string; name: string; symbol: string }>(currencies[0] || { code: 'USD', name: 'US Dollar', symbol: 'US$' })
const dropdown = ref(false)
const currenciesDropdown = ref(null as any)

//methods
function selectCurrency(currency: { code: string; name: string; symbol: string } | undefined) {
  if (!currency) return
  Cookies.set('currency', currency.code)
  accountStore.setCurrency(currency as { code: string; name: string; symbol: string })
  // The guest picked a currency, so checkout must stop restating the order in the one the hotel
  // page showed them (an MXN/TWD/KRW Google landing) — otherwise choosing USD changes nothing.
  bookingStore.clearDisplayCurrency()
  selectedCurrency.value = currency;
  menuVisible.value = false;
  dropdown.value = false;
  window.location.reload()
}

function toggleDropdown() {
  dropdown.value = !dropdown.value
}

function handleClickOutside(e: any) {
  const currenyDropdoen = currenciesDropdown.value;
  if (e.target instanceof Element && currenyDropdoen && !(currenyDropdoen as any).contains(e.target)) {
    dropdown.value = false;
  }
}

onMounted(() => {
  // if (locale?.value) {
  //   selectedCurrency.value = languages.find(lang => lang.code === locale.value)
  // }

  const currency = Cookies.get('currency') || 'USD';
  const found = currencies.find((c: { code: string }) => c.code === currency)
  if (found) {
    selectedCurrency.value = found
  } else if (isSupportedCurrency(currency)) {
    // Session currency set from a Google/URL landing (e.g. SGD) that we still want to reflect.
    selectedCurrency.value = currencyInfo(currency)
  }
  accountStore.setCurrency(selectedCurrency.value)
  document.addEventListener('click', handleClickOutside);
})
</script>
<style lang="scss" scoped>
.currency-selector {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  .flex {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 36px;
    padding: 0 10px;
    border-radius: 8px;
    border: 1px solid var(--grey-border);
    transition: all 0.2s ease;

    &:hover {
      background: var(--light-grey);
    }
  }

  .currency-symbol {
    font-size: 14px;
    font-weight: 700;
    color: var(--dark-grey);
  }

  .icon {
    font-size: 10px;
    display: flex;
    align-items: center;
    color: var(--dark-grey);
  }

  &--currency {
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
  }
}

.menu-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;

  .currency-symbol {
    font-size: 15px;
    font-weight: 700;
    color: var(--dark-grey);
    width: 20px;
    text-align: center;
    flex-shrink: 0;
  }

  // Override .currency-selector .icon (same specificity 0-2-0, wins by source order)
  .icon {
    font-size: 11px;
    color: var(--dark-grey-secondary);
    transform: rotate(-90deg);
    flex-shrink: 0;
  }

  &__label {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: var(--black);
  }
}

.currency-dropdown {
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 3000;
  min-width: 240px;
}
</style>
